(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["prink-alternative-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('prink-alternative-notice')) {
  customElements.define('prink-alternative-notice', class extends HTMLElement {
    connectedCallback() {
      if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>{if(this.isConnected)this.setup();},{once:true});
      else this.setup();
    }
    setup() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.key = 'studio-alternative-seen-' + this.dataset.productId;
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, options);
      this.querySelector('[data-view]').addEventListener('click', () => this.dialog.close(), options);
      this.querySelector('[data-continue]').addEventListener('click', () => {
        const form = this.pendingForm;
        const submitter = this.pendingSubmitter;
        this.dialog.close();
        if (!form?.isConnected) return;
        this.bypass = true;
        if (submitter?.isConnected && submitter.form === form) form.requestSubmit(submitter);
        else form.requestSubmit();
        this.bypass = false;
      }, options);
      document.addEventListener('submit', (event) => {
        const verification = this.closest('[data-pw-canonical-check]');
        if (verification && verification.dataset.pwVerified !== 'true') return;
        const form = event.target;
        if (this.bypass || !(form instanceof HTMLFormElement)) return;
        if (form.getAttribute('id') !== 'StudioProductForm') return;
        if (form.querySelector('[name="id"]')?.value !== this.dataset.variantId) return;
        if (event.submitter?.disabled || event.submitter?.getAttribute('aria-disabled') === 'true') return;
        let seen = this.seen;
        try { seen = seen || sessionStorage.getItem(this.key) === '1'; } catch (_) {}
        if (seen) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.pendingForm = form;
        this.pendingSubmitter = event.submitter;
        this.dialog.showModal();
        this.seen = true;
        try { sessionStorage.setItem(this.key, '1'); } catch (_) {}
      }, { capture: true, signal: this.abort.signal });
    }
    disconnectedCallback() {
      this.abort?.abort();
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["studio-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit',async event=>{
  const form=event.target;
  if(!(form instanceof HTMLFormElement)||!form.matches('[data-quick-add]'))return;
  event.preventDefault();
  if(form.dataset.busy)return;
  const button=form.querySelector('button[type=submit]'),card=form.closest('.product-card'),status=card.querySelector('.quick-status'),cartLink=card.querySelector('.quick-cart-link');
  form.dataset.busy='true';button.disabled=true;button.setAttribute('aria-busy','true');button.setAttribute('aria-label',button.dataset.loading);button.removeAttribute('data-added');status.textContent=button.dataset.loading;cartLink.hidden=true;
  try{
    const response=await fetch(form.action.replace(/\/$/,'')+'.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
    const result=await response.json();
    if(!response.ok){status.textContent=result.description||button.dataset.error;cartLink.hidden=false;return}
    status.textContent=button.dataset.success;button.dataset.added='true';cartLink.hidden=false;
    try{const res=await fetch((window.routes?.cart_url||'/cart')+'.js',{headers:{Accept:'application/json'}});if(res.ok){const cart=await res.json();document.querySelectorAll('[data-studio-cart-count]').forEach(el=>el.textContent=String(cart.item_count));document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart}}))}}catch{}
  }catch{status.textContent=button.dataset.error;cartLink.hidden=false}
  finally{delete form.dataset.busy;button.disabled=false;button.removeAttribute('aria-busy');button.setAttribute('aria-label',button.dataset.idleLabel)}
});
  } catch(e) { console.error(e); }
})();

})();
